module.exports = __webpack_public_path__ + "static/media/jessie.1b17293a.jpg";